import { useMemo } from "react"

export default function useUsersSelectValues(
    userRef: { [key: string]: any },
    options?: { valueKey?: 'email' | '_id' }
) {
    const valueKey = options?.valueKey || 'email'
    const userSelectOptions = useMemo(() => {
        const seen = new Set<string>()
        const selectOptions = []
        for (const key in userRef) {
            const user = userRef[key]
            const val = user[valueKey]
            if (seen.has(val)) continue
            seen.add(val)
            selectOptions.push({
                text: `${user.firstName} ${user.lastName}`,
                value: val,
            })
        }
        return selectOptions.sort((x, y) => x.text.localeCompare(y.text))
    }, [userRef, valueKey])
    return userSelectOptions
}